import { MapGroupId } from "../../types";
import customsMainImg from "../../mapImages/CustomsMain.webp";

const mapData = {
  groupId: MapGroupId.Customs,
  groupName: {
    en: "Customs",
    ru: "Таможня",
  },
  title: {
    en: "Main",
    ru: "Главная",
  },
  imgPath: customsMainImg,
  extracts: [],
};

export default mapData;
